import styled from "styled-components";

export const Wrapper = styled.div`
  .auctionTable {
    min-width: 2000px;
  }
  .sortColumn {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    svg {
      width: 10px;
      height: 15px;
    }
  }
  .show {
    display: block;
    transition: all 0.8s ease-in-out;
  }
  .hide {
    display: none;
    transition: all 0.8s ease-in-out;
  }
  .open {
    transform: rotate(0deg);
    -webkit-transition: all 0.35s ease-in-out;
    transition: all 0.35s ease-in-out;
  }
  .close {
    transform: rotate(-180deg);
    -webkit-transition: all 0.35s ease-in-out;
    transition: all 0.35s ease-in-out;
    left: 0px !important;
  }
  .filterbtn {
    width: auto;
    position: absolute;
    left: 15%;
    /* right: 10px; */
    top: 55px;
    cursor: pointer;
  }
  .userName {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .profileIcon {
    width: 16px;
    height: 16px;
    stroke: blue;
    fill: blue;
    margin-left: 5px;
  }
  .rightSideFilters {
    width: 100%;
    .filterHeader {
      width: 100%;
      display: block;
      text-align: center;
      font-weight: 600;
      font-size: 20px;
    }
    .filterBox {
      border-radius: 0.25rem !important;
      height: 40px !important;
      width: 100% !important;
      .MuiInputBase-root {
        height: 40px !important;
      }
    }
  }
  .form-label {
    font-size: 14px;
  }
  .dateFilter {
    display: flex;
    flex-direction: row;
    gap: 10px;
    input {
      width: -webkit-fill-available;
      max-width: 50%;
      border-radius: 0;
    }
  }
  .actionButtons {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .accept {
    color: #5d78ff;
    border: 1px solid #5d78ff;
    font-weight: 700;
    font-size: 14px;
    background: white;
    letter-spacing: 1px;
    padding: 4px 22px;
    border-radius: 3px;
    word-break: normal;
  }

  .reject {
    padding: 4px 22px;
    color: #ff2828;
    font-weight: 700;
    border: 1px solid #ff2828 !important;
    font-size: 14px;
    background: white;
    letter-spacing: 1px;
    border-radius: 3px;
    word-break: normal;
  }
`;
